<div class="title">
  <h3>
    {{selectedItem?.description}}
  </h3>
</div>
<div class="widget-filter">
  <div class="inline-elements">
    <input type="checkbox" [ngClass]="{'selectedCheckbox' : selectedFilterOption == filterOption.ShowAllWidgets}" (click)="changeFilterOption(filterOption.ShowAllWidgets)" />
    <span>{{'localizationFormList.filterShowAllOption' | translate }}</span>
  </div>
  <div class="inline-elements">
    <input type="checkbox" [ngClass]="{'selectedCheckbox' : selectedFilterOption == filterOption.WidgetsUsed}" (click)="changeFilterOption(filterOption.WidgetsUsed)" />
    <span>{{'localizationFormList.filterWidgetUsedOption' | translate }}</span>
  </div>
  <div class="inline-elements template-dropdown">
    <input type="checkbox" [ngClass]="{'selectedCheckbox' : selectedFilterOption == filterOption.TemplateName}" (click)="changeFilterOption(filterOption.TemplateName)" />
    <div class="template-dropdown-content">
      <span>{{'localizationFormList.filterTemplateOption' | translate }}</span>
      <kendo-dropdownlist [disabled]="selectedFilterOption != filterOption.TemplateName"
                          [data]="templates"
                          [valuePrimitive]="true"
                          [textField]="'Name'"
                          [valueField]="'Oid'"
                          [defaultItem]="templateDefaultItem"
                          (valueChange)="onTemplateSelection($event)"
                          [(ngModel)]="selectedTemplateOid">
      </kendo-dropdownlist>
    </div>
  </div>
</div>
<div class="widgets-list">
  <div class="side-block-title">
    <svg-icon src='./assets/icons/ReportDesigner.svg'
              title="Users"
              class="menu-action-icon svg-icon-red"
              align='center'>
    </svg-icon>
    <h4 class="widgets-list-title">
      {{'localizationFormList.widgetsTitle' | translate | uppercase}}
    </h4>
  </div>
  <div class="widgets-list-body-left">
    <div>
      <p class="no-data-title" *ngIf="filteredWidgetData?.length <= 0">
        {{'localizationFormList.noData' | translate}}
      </p>
    </div>
    <div class="widget-list-item" *ngFor="let widget of filteredWidgetData">
      <svg-icon *ngIf="widget.actionStageId == actionStage.Pending "
                (click)="updateTaskActionStage(task)"
                src='./assets/icons/ReportDesigner.svg'
                alt="NEW"
                class="raci-icon svg-icon-new"
                align='center'>
      </svg-icon>
      <svg-icon *ngIf="widget.actionStageId == actionStage.InProgress"
                (click)="updateTaskActionStage(task)"
                src='./assets/icons/circle-half-stroke-solid.svg'
                alt="IN PROGRESS"
                class="raci-icon svg-icon-in-progress"
                align='center'>
      </svg-icon>
      <svg-icon *ngIf="widget.actionStageId == actionStage.Completed"
                src='./assets/icons/checkmark.svg'
                alt="COMPLETED"
                class="raci-icon raci-step-icon-done"
                align='center'>
      </svg-icon>
      <h4 [ngClass]="{'widget-selected': widget.selected, 'disabled-icon': !displayBackToReportDesigner}" title="{{widget.title?.toUpperCase()}}" class="widgets-list-name" (click)="onSelectWidget(widget)">
        {{widget.title?.toUpperCase()}}
      </h4>
    </div>
  </div>
</div>
